import type { FC } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useNickNameInfoSlice } from '../../../store/slices/nickname/selectors';

import styles from './NickNameFooterMessage.module.css';

export const NickNameEditFooterMessageConnected: FC = () => {
  const { maxCount, remainingAttempts } = useNickNameInfoSlice.getNickNameInfo();

  const supportingMessage = remainingAttempts ? 'SETTINGS_CHANGE_NICKNAME' : 'SETTINGS_MAX_LIMIT_NICKNAME';

  return (
    <div className={styles.nickNameSettingsFooter}>
      <L10nText
        tk={supportingMessage}
        markdown
        dynamicValues={[
          `${maxCount}`,
          `<span style="color: var(--core-color-text)">${remainingAttempts}/${maxCount} </span>`,
        ]}
      />
    </div>
  );
};
